var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "d-lg-none" }, [
      _vm.isLoggedIn
        ? _c("div", { staticClass: "dropdown" }, [
            _c(
              "div",
              {
                staticClass: "d-block text-center flex-wrap dropdown-toggle",
                attrs: {
                  id: "dropdownMenuButton2",
                  "data-toggle": "dropdown",
                  "aria-haspopup": "true",
                  "aria-expanded": "false"
                }
              },
              [
                _c("svg", { attrs: { width: "18", height: "20" } }, [
                  _c("use", {
                    attrs: {
                      "xlink:href": "#svg_new-user",
                      "xmlns:xlink": "https://www.w3.org/1999/xlink"
                    }
                  })
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.$translate("Froschkoenig::Template.headerMyAccount")
                    )
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "dropdown-menu",
                attrs: { "aria-labelledby": "dropdownMenuButton2" }
              },
              [
                _c(
                  "a",
                  {
                    staticClass: "dropdown-item",
                    attrs: { href: _vm.$ceres.urls.myAccount }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$translate("Ceres::Template.loginMyAccount"))
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    directives: [{ name: "logout", rawName: "v-logout" }],
                    staticClass: "dropdown-item",
                    attrs: { href: "#" }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$translate("Ceres::Template.loginLogout"))
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "dropdown-item",
                    attrs: { href: "/wish-list" }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$translate("Froschkoenig::Template.headerWishlist")
                      )
                    )
                  ]
                )
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.isLoggedIn
        ? _c("div", [
            _c(
              "div",
              {
                staticClass: "d-block text-center flex-wrap dropdown-toggle",
                attrs: {
                  id: "dropdownMenuButton2",
                  "data-toggle": "dropdown",
                  "aria-haspopup": "true",
                  "aria-expanded": "false"
                }
              },
              [
                _c("svg", { attrs: { width: "18", height: "20" } }, [
                  _c("use", {
                    attrs: {
                      "xlink:href": "#svg_new-user",
                      "xmlns:xlink": "https://www.w3.org/1999/xlink"
                    }
                  })
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.$translate("Froschkoenig::Template.headerMyAccount")
                    )
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "dropdown-menu",
                attrs: { "aria-labelledby": "dropdownMenuButton2" }
              },
              [
                _c(
                  "a",
                  {
                    staticClass: "dropdown-item",
                    attrs: { "data-toggle": "modal", href: "#login" },
                    on: {
                      click: function($event) {
                        _vm.createLoginModal()
                        _vm.unmarkInputFields()
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$translate("Froschkoenig::Template.headerLogin")
                      )
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "dropdown-item",
                    attrs: { "data-toggle": "modal", href: "#registration" },
                    on: {
                      click: function($event) {
                        _vm.createRegisterModal()
                        _vm.unmarkInputFields()
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$translate("Froschkoenig::Template.headerRegister")
                      )
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "dropdown-item",
                    attrs: { href: "/wish-list" }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$translate("Froschkoenig::Template.headerWishlist")
                      )
                    )
                  ]
                )
              ]
            )
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "d-none d-lg-block" }, [
      _vm.isLoggedIn
        ? _c("div", { staticClass: "dropdown" }, [
            _c(
              "div",
              {
                staticClass: "dropdown-toggle",
                attrs: {
                  id: "dropdownMenuButton1",
                  "data-toggle": "dropdown",
                  "aria-haspopup": "true",
                  "aria-expanded": "false"
                }
              },
              [
                _c("a", { attrs: { href: _vm.$ceres.urls.myAccount } }, [
                  _c("svg", { attrs: { width: "13", height: "15" } }, [
                    _c("use", {
                      attrs: {
                        "xlink:href": "#svg_new-user",
                        "xmlns:xlink": "https://www.w3.org/1999/xlink"
                      }
                    })
                  ]),
                  _vm._v(
                    _vm._s(
                      _vm.$translate("Froschkoenig::Template.headerMyAccount")
                    )
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "dropdown-menu",
                attrs: { "aria-labelledby": "dropdownMenuButton1" }
              },
              [
                _c(
                  "a",
                  {
                    staticClass: "dropdown-item",
                    attrs: { href: _vm.$ceres.urls.myAccount }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$translate("Ceres::Template.loginMyAccount"))
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    directives: [{ name: "logout", rawName: "v-logout" }],
                    staticClass: "dropdown-item",
                    attrs: { href: "#" }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$translate("Ceres::Template.loginLogout"))
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "dropdown-item",
                    attrs: { href: "/wish-list" }
                  },
                  [_vm._v("Merkliste")]
                )
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.isLoggedIn
        ? _c("div", [
            _c(
              "div",
              {
                staticClass: "dropdown-toggle",
                attrs: {
                  id: "dropdownMenuButton1",
                  "data-toggle": "dropdown",
                  "aria-haspopup": "true",
                  "aria-expanded": "false"
                }
              },
              [
                _c("a", { attrs: { href: _vm.$ceres.urls.myAccount } }, [
                  _c("svg", { attrs: { width: "13", height: "15" } }, [
                    _c("use", {
                      attrs: {
                        "xlink:href": "#svg_new-user",
                        "xmlns:xlink": "https://www.w3.org/1999/xlink"
                      }
                    })
                  ]),
                  _vm._v(
                    _vm._s(
                      _vm.$translate("Froschkoenig::Template.headerMyAccount")
                    )
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "dropdown-menu",
                attrs: { "aria-labelledby": "dropdownMenuButton1" }
              },
              [
                _c(
                  "a",
                  {
                    staticClass: "dropdown-item",
                    attrs: { "data-toggle": "modal", href: "#login" },
                    on: {
                      click: function($event) {
                        _vm.createLoginModal()
                        _vm.unmarkInputFields()
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$translate("Froschkoenig::Template.headerLogin")
                      )
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "dropdown-item",
                    attrs: { "data-toggle": "modal", href: "#registration" },
                    on: {
                      click: function($event) {
                        _vm.createRegisterModal()
                        _vm.unmarkInputFields()
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$translate("Froschkoenig::Template.headerRegister")
                      )
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "dropdown-item",
                    attrs: { href: "/wish-list" }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$translate("Froschkoenig::Template.headerWishlist")
                      )
                    )
                  ]
                )
              ]
            )
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }